// extracted by mini-css-extract-plugin
export default {"container":"StageOptions_container__pNjiH","single":"StageOptions_single__enK+c","prefix":"StageOptions_prefix__p5y6f"};